const SectionTitleBlock = ({ block }) => {
  return (
    <h2 className="section-title-block">
      {block.content}
    </h2>
  );
};

export default SectionTitleBlock;